<div class="betbuilder-market" *ngFor="let market of markets">
    <ms-bet-builder-market-card [event]="event" [fixtureId]="fixtureId" [market]="market" [showName]="showName"></ms-bet-builder-market-card>
</div>
